export const guessImgBinaryExtension = (binary) => {
    const arr = (new Uint8Array(binary)).subarray(0, 4)
    let hex = ''
    for (var i = 0; i < arr.length; i++) {
        hex += arr[i].toString(16)
    }
    switch (hex) {
        case '89504e47':
            return 'png'
        case '47494638':
            return 'gif'
        case 'ffd8ffe0':
        case 'ffd8ffe1':
        case 'ffd8ffe2':
        case 'ffd8ffe3':
        case 'ffd8ffe8':
            return 'jpg'
        default:
            return null
    }
}